import * as React from "react"
import {ListItemButton, ListItemIcon, ListItemText, useTheme} from "@mui/material";
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"

import {useActiveLink, useTextCut} from "../../../../../../@hooks";
import {MaximalLayoutNavMiniItemStyles, MaximalLayoutNavMiniArrow, MaximalLayoutNavMiniIconStyles} from "./styles";


export default function MaximalLayoutNavMiniItem({ path, title, icon, hasChildren=false, active: activeProp, sx={} }) {
    const theme = useTheme()
    const { active: linkActive } = useActiveLink(path, hasChildren)
    // Group icons have no `path`; their active state is supplied by the NavList
    // (true when any child route matches the current location).
    const active = activeProp ?? linkActive

    // The 72 px label ends in "…" (noWrap) and shows whole on hover or focus, only when it is cut (CU-869fmjzrg).
    // Below the icon, so it never covers the section's flyout on the right
    const [labelRef, labelCut] = useTextCut(title)

    const textConfig = {
        ref: labelRef,
        noWrap: true,
        sx: {
            width: 72,
            fontSize: 10,
            lineHeight: '16px',
            textAlign: 'center',
            ...(active && {
                fontWeight: 'fontWeightMedium'
            })
        }
    }

    const sxBtn = MaximalLayoutNavMiniItemStyles(active, hasChildren, theme)
    return <TooltipSeeker title={labelCut ? title : ''} placement="bottom">
        <ListItemButton sx={{ ...sxBtn, ...sx.button }}>
            <ListItemIcon sx={{ ...MaximalLayoutNavMiniIconStyles, ...sx.icon }}>
                <IconSeeker  icon={icon} />
            </ListItemIcon>

            <ListItemText primary={title} primaryTypographyProps={textConfig} />

            { hasChildren && <IconSeeker icon="chevron-right" sx={MaximalLayoutNavMiniArrow} /> }
        </ListItemButton>
    </TooltipSeeker>
}